(function () {
  if (window.customElements && customElements.get('bz-buybox')) return;

  function delim(n, dec, thou, sep) {
    var parts = n.toFixed(dec).split('.');
    var whole = parts[0], out = '';
    while (whole.length > 3) { out = thou + whole.slice(-3) + out; whole = whole.slice(0, -3); }
    parts[0] = whole + out;
    return parts.join(sep);
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (Number(cents) || 0) / 100;
    var a = fmt.indexOf('{{'), b = fmt.indexOf('}}', a + 2);
    var ok = a > -1 && b > a;
    var key = ok ? fmt.slice(a + 2, b).trim() : 'amount';
    var out;
    if (key === 'amount_no_decimals') out = delim(value, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') out = delim(value, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') out = delim(value, 0, '.', ',');
    else out = delim(value, 2, ',', '.');
    return ok ? fmt.slice(0, a) + out + fmt.slice(b + 2) : out;
  }

  class BzBuybox extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var dataEl = this.querySelector('script[data-bz-data]');
      if (!dataEl) return;
      try { this.data = JSON.parse(dataEl.textContent); } catch (e) { console.error('BADGZ buy box data error', e); return; }

      var self = this;
      this.variants = this.data.variants || [];
      this.byId = new Map(this.variants.map(function (v) { return [String(v.id), v]; }));
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-tier]'));
      this.tiles = Array.prototype.slice.call(this.querySelectorAll('[data-variant-id]'));
      this.slotsEl = this.querySelector('[data-slots]');
      this.statusEl = this.querySelector('[data-status]');
      this.ctaBtn = this.querySelector('[data-add]');
      this.ctaPrice = this.querySelector('[data-cta-price]');
      this.msgEl = this.querySelector('[data-msg]');
      this.picks = [];
      this.packSize = 1;
      this.discount = 0;
      this.unit = this.minUnit();

      var urlV = new URLSearchParams(window.location.search).get('variant');
      var start = (urlV && this.byId.has(urlV)) ? urlV : String(this.data.selected || '');
      var sv = this.byId.get(start);
      this.startId = (sv && sv.available) ? start : this.firstAvailable();

      this.tiers.forEach(function (t) {
        t.addEventListener('click', function () { self.selectTier(t); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.selectTier(t); }
        });
      });
      this.tiles.forEach(function (b) {
        b.addEventListener('click', function () { self.tapTile(b.dataset.variantId); });
      });
      this.querySelectorAll('[data-minus]').forEach(function (b) {
        b.addEventListener('click', function () { self.removeOne(b.dataset.minus); });
      });
      if (this.ctaBtn) this.ctaBtn.addEventListener('click', function () { self.addToCart(); });

      this.renderTierPrices();
      var def = this.tiers.find(function (t) { return t.hasAttribute('data-default'); }) || this.tiers[0];
      if (def) { this.selectTier(def, true); }
      else { this.packSize = 1; this.picks = this.startId ? [this.startId] : []; this.update(); }

      this.initGallery();
      this.initModal();
      this.initSticky();
    }

    get single() { return !!this.data.single || this.tiles.length === 0; }

    minUnit() {
      var av = this.variants.filter(function (v) { return v.available; });
      var list = av.length ? av : this.variants;
      return list.length ? Math.min.apply(null, list.map(function (v) { return v.price; })) : 0;
    }

    firstAvailable() {
      var v = this.variants.find(function (x) { return x.available; });
      return v ? String(v.id) : null;
    }

    selectTier(t, initial) {
      this.tiers.forEach(function (x) { x.setAttribute('aria-checked', x === t ? 'true' : 'false'); });
      this.packSize = Math.max(1, parseInt(t.dataset.qty, 10) || 1);
      this.discount = Math.min(90, Math.max(0, parseFloat(t.dataset.discount) || 0));
      if (this.single) {
        var id = this.startId || this.firstAvailable();
        this.picks = [];
        for (var i = 0; i < this.packSize && id; i++) this.picks.push(id);
      } else if (initial || this.picks.length === 0) {
        this.picks = this.startId ? [this.startId] : [];
      } else if (this.packSize === 1) {
        this.picks = this.picks.slice(-1);
      } else if (this.picks.length > this.packSize) {
        this.picks = this.picks.slice(0, this.packSize);
      }
      this.update();
    }

    tapTile(id) {
      id = String(id);
      var v = this.byId.get(id);
      if (!v || !v.available) return;
      if (this.packSize === 1) {
        this.picks = [id];
      } else if (this.picks.length < this.packSize) {
        this.picks.push(id);
      } else {
        this.flash(this.data.fullMsg || 'Pack is full. Tap a design in your pack to remove it.');
        return;
      }
      this.update();
      if (v.mediaId) this.goToMedia(v.mediaId);
    }

    removeOne(id) {
      var i = this.picks.lastIndexOf(String(id));
      if (i > -1) { this.picks.splice(i, 1); this.update(); }
    }

    removeAt(i) { this.picks.splice(i, 1); this.update(); }

    totals() {
      var sum = 0;
      for (var i = 0; i < this.packSize; i++) {
        var v = this.byId.get(this.picks[i]);
        sum += v ? v.price : this.unit;
      }
      return { sum: sum, disc: Math.round(sum * (1 - this.discount / 100)) };
    }

    fmt(c) { return formatMoney(c, this.data.moneyFormat); }

    renderTierPrices() {
      var self = this;
      this.tiers.forEach(function (t) {
        var q = Math.max(1, parseInt(t.dataset.qty, 10) || 1);
        var d = parseFloat(t.dataset.discount) || 0;
        var full = self.unit * q;
        var disc = Math.round(full * (1 - d / 100));
        var P = t.querySelector('[data-price]'), C = t.querySelector('[data-compare]'), E = t.querySelector('[data-each]');
        if (P) P.textContent = self.fmt(disc);
        if (C) C.textContent = disc < full ? self.fmt(full) : '';
        if (E) E.textContent = q > 1 ? self.fmt(Math.round(disc / q)) + ' ' + (self.data.eachLabel || 'each') : '';
      });
    }

    update() {
      var self = this;
      var counts = {};
      this.picks.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var multi = this.packSize > 1;

      this.tiles.forEach(function (b) {
        var n = counts[b.dataset.variantId] || 0;
        b.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
        var wrap = b.parentElement;
        var c = wrap.querySelector('[data-count]');
        var m = wrap.querySelector('[data-minus]');
        if (c) { c.textContent = n; c.hidden = !(n > 0 && multi); }
        if (m) { m.hidden = !(n > 0 && multi); }
      });

      if (this.slotsEl) {
        this.slotsEl.innerHTML = '';
        this.slotsEl.hidden = !multi || this.single;
        for (var i = 0; i < this.packSize; i++) {
          (function (idx) {
            var id = self.picks[idx];
            var s = document.createElement('button');
            s.type = 'button';
            s.className = 'bz-slot';
            if (id) {
              var v = self.byId.get(id);
              s.classList.add('bz-slot--filled');
              s.setAttribute('aria-label', 'Remove ' + (v ? v.title : 'design'));
              if (v && v.image) {
                var img = document.createElement('img');
                img.src = v.image; img.alt = '';
                s.appendChild(img);
              } else {
                s.textContent = v ? v.title.slice(0, 3) : '';
              }
              s.addEventListener('click', function () { self.removeAt(idx); });
            } else {
              s.textContent = String(idx + 1);
              s.disabled = true;
              s.setAttribute('aria-label', 'Empty slot ' + (idx + 1));
            }
            self.slotsEl.appendChild(s);
          })(i);
        }
      }

      var left = this.packSize - this.picks.length;
      if (this.statusEl) {
        if (this.single) {
          this.statusEl.textContent = '';
        } else if (left > 0) {
          this.statusEl.textContent = multi ? ('Pick ' + left + ' more') : 'Pick a design';
          this.statusEl.classList.remove('bz-status--ok');
        } else {
          this.statusEl.textContent = multi ? 'Pack complete ✓' : '';
          this.statusEl.classList.add('bz-status--ok');
        }
      }

      var t = this.totals();
      if (this.ctaPrice) this.ctaPrice.textContent = '— ' + this.fmt(t.disc);
      if (this.stickyPrice) this.stickyPrice.textContent = this.fmt(t.disc);
      if (this.msgEl) this.msgEl.textContent = '';
    }

    flash(msg) { if (this.msgEl) this.msgEl.textContent = msg; }

    addToCart() {
      var self = this;
      var left = this.packSize - this.picks.length;
      if (left > 0) {
        this.flash(this.packSize > 1
          ? ('Pick ' + left + ' more design' + (left > 1 ? 's' : '') + ' to complete your pack.')
          : 'Pick a design first.');
        var picker = this.querySelector('[data-picker]');
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var agg = {};
      this.picks.slice(0, this.packSize).forEach(function (id) { agg[id] = (agg[id] || 0) + 1; });
      var items = Object.keys(agg).map(function (id) { return { id: Number(id), quantity: agg[id] }; });
      var btn = this.ctaBtn;
      btn.disabled = true;
      btn.classList.add('is-loading');
      var root = this.data.root || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart.');
          window.location.href = root + (self.data.afterAdd === 'checkout' ? 'checkout' : 'cart');
        });
      }).catch(function (err) {
        self.flash(err.message || 'Something went wrong. Try again.');
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
    }

    initGallery() {
      var self = this;
      this.viewport = this.querySelector('[data-viewport]');
      if (!this.viewport) return;
      this.slides = Array.prototype.slice.call(this.viewport.children);
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.goTo(i); }); });
      var prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(Math.max(0, self.current() - 1)); });
      if (next) next.addEventListener('click', function () { self.goTo(Math.min(self.slides.length - 1, self.current() + 1)); });
      var raf;
      this.viewport.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { self.markThumb(); });
      }, { passive: true });
      this.markThumb();
    }

    current() {
      var w = this.viewport.clientWidth || 1;
      return Math.round(this.viewport.scrollLeft / w);
    }

    goTo(i) {
      if (!this.viewport) return;
      this.viewport.scrollTo({ left: i * this.viewport.clientWidth, behavior: 'smooth' });
    }

    markThumb() {
      var c = this.current();
      (this.thumbs || []).forEach(function (t, i) { t.setAttribute('aria-current', i === c ? 'true' : 'false'); });
    }

    goToMedia(mediaId) {
      if (!this.slides) return;
      var i = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (i > -1) this.goTo(i);
    }

    initModal() {
      var open = this.querySelector('[data-open-modal]');
      var dlg = this.querySelector('[data-modal]');
      if (!open || !dlg) return;
      function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
      open.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
      dlg.querySelectorAll('[data-close-modal]').forEach(function (b) { b.addEventListener('click', close); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    }

    initSticky() {
      var self = this;
      var bar = this.querySelector('[data-sticky]');
      if (!bar || !this.ctaBtn || !('IntersectionObserver' in window)) return;
      if (window.Shopify && window.Shopify.designMode) return;
      document.body.appendChild(bar);
      bar.hidden = false;
      this.stickyPrice = bar.querySelector('[data-sticky-price]');
      var btn = bar.querySelector('[data-sticky-btn]');
      if (btn) btn.addEventListener('click', function () {
        var target = self.querySelector('[data-pack-anchor]') || self;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      var ctaVisible = true;
      function toggle() { bar.classList.toggle('is-visible', !ctaVisible && window.scrollY > 600); }
      new IntersectionObserver(function (entries) { ctaVisible = entries[0].isIntersecting; toggle(); }).observe(this.ctaBtn);
      window.addEventListener('scroll', toggle, { passive: true });
      this.update();
    }
  }

  customElements.define('bz-buybox', BzBuybox);
})();
